module.exports = __webpack_public_path__ + "static/media/customer-background.161bdaf6.png";